"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _communityComment = require("@/api/community/communityComment");
var _memberManagement = require("@/api/member/memberManagement");
var _DetailView = _interopRequireDefault(require("../DetailView.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PraiseRankList',
  components: {
    CommunityDynamicsDetail: _DetailView.default
  },
  data: function data() {
    return {
      tableLoading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        timeRange: [],
        orderByPraise: 1 // 赞排行标识
      },
      imagePrefix: '',
      exportLoading: false,
      // 置顶对话框相关数据
      topDialogVisible: false,
      topDialogForm: {
        id: null,
        startTime: '',
        endTime: ''
      },
      topDialogRow: null // 保存当前操作的行数据
    };
  },
  mounted: function mounted() {
    this.fetchData();
    this.fetchImagePrefix();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      this.tableLoading = true;
      var query = _objectSpread({
        page: this.currentPage,
        limit: this.pageSize,
        orderByPraise: this.searchForm.orderByPraise
      }, this.searchForm);

      // 处理时间范围参数
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        query.startTime = this.searchForm.timeRange[0];
        query.endTime = this.searchForm.timeRange[1];
      }

      // 删除不需要的参数
      delete query.timeRange;
      (0, _communityComment.listCommentPage)(query).then(function (response) {
        if (response.code === 200) {
          _this.tableData = response.records || [];
          _this.total = response.total || 0;
        } else {
          _this.$message.error(response.message || '获取赞排行数据失败');
        }
      }).catch(function (error) {
        console.error('获取赞排行数据失败:', error);
        _this.$message.error('获取赞排行数据失败: ' + (error.message || '未知错误'));
      }).finally(function () {
        _this.tableLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    // 查看详情
    handleViewDetail: function handleViewDetail(row) {
      // 触发事件，让父组件处理详情页展示，9：置顶赞排行
      this.$emit('view-detail', row, 9);
    },
    // 获取图片前缀
    fetchImagePrefix: function () {
      var _fetchImagePrefix = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchImagePrefix() {
        return _fetchImagePrefix.apply(this, arguments);
      }
      return fetchImagePrefix;
    }(),
    // 获取完整图片URL
    getImageUrl: function getImageUrl(imgPath) {
      // 如果已经是完整URL，则直接返回
      if (imgPath && (imgPath.startsWith('http://') || imgPath.startsWith('https://'))) {
        return imgPath;
      }
      // 使用动态获取的图片前缀
      return imgPath ? this.imagePrefix + imgPath : '';
    },
    // 格式化置顶时间
    formatTopTime: function formatTopTime(startTime, endTime) {
      if (!startTime && !endTime) {
        return '-';
      }
      return "".concat(startTime || '', " - ").concat(endTime || '');
    },
    // 处理广场/审核操作
    handleAuditOrRecommend: function handleAuditOrRecommend(row, type) {
      var _this2 = this;
      // type = 1 广场，type = 2 审核
      (0, _communityComment.userContentCommentsAudit)(row.id, type).then(function (response) {
        if (response.code === 200) {
          _this2.$message.success('操作成功');
          // 重新加载数据
          _this2.fetchData();
        } else {
          _this2.$message.error(response.message || '操作失败');
        }
      }).catch(function (error) {
        _this2.$message.error('操作失败: ' + error.message);
      });
    },
    // 处理置顶操作
    handleToggleTop: function handleToggleTop(row) {
      // 如果当前是"否"，点击后需要弹出对话框设置时间
      if (row.isTop !== 1) {
        // 显示对话框，让用户设置开始和结束时间
        this.topDialogRow = row;
        this.topDialogForm.id = row.id;
        this.topDialogForm.startTime = '';
        this.topDialogForm.endTime = '';
        this.topDialogVisible = true;
      } else {
        // 如果当前是"是"，直接取消置顶
        this.confirmTopAction(row, 0, null, null);
      }
    },
    // 确认置顶操作
    confirmTopAction: function confirmTopAction(row, isTop, startTime, endTime) {
      var _this3 = this;
      // 构造更新数据
      var updateData = {
        id: row.id,
        isTop: isTop,
        startTime: startTime,
        endTime: endTime
      };

      // 调用更新接口
      (0, _communityComment.updateComment)(updateData).then(function (response) {
        if (response.code === 200) {
          _this3.$message.success('置顶状态更新成功');
          // 重新加载数据
          _this3.fetchData();
        } else {
          _this3.$message.error(response.message || '置顶状态更新失败');
        }
      }).catch(function (error) {
        _this3.$message.error('置顶状态更新失败: ' + error.message);
      });
    },
    // 保存置顶设置
    saveTopSetting: function saveTopSetting() {
      if (!this.topDialogForm.startTime || !this.topDialogForm.endTime) {
        this.$message.warning('请填写开始时间和结束时间');
        return;
      }

      // 关闭对话框
      this.topDialogVisible = false;

      // 执行置顶操作
      this.confirmTopAction(this.topDialogRow, 1,
      // 设置为置顶
      new Date(this.topDialogForm.startTime).getTime(), new Date(this.topDialogForm.endTime).getTime());
    },
    // 移除评论
    handleRemove: function handleRemove(row) {
      var _this4 = this;
      this.$confirm('确定要移除该评论吗？', '提示', {
        confirmButtonText: '确定移除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _communityComment.deleteComment)(row.id).then(function (response) {
          if (response.code === 200) {
            _this4.$message.success('移除成功');
            _this4.fetchData();
          } else {
            // 检查是否是因为文章已被展示而无法删除
            if (response.message && response.message.includes('文章已被展示')) {
              _this4.$message.error('文章已被展示，无法删除，请取消展示后重试');
            } else {
              _this4.$message.error(response.message || '移除失败');
            }
          }
        }).catch(function (error) {
          _this4.$message.error('移除失败: ' + error.message);
        });
      }).catch(function () {
        _this4.$message.info('已取消移除');
      });
    }
  }
};